// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect-econtador[data-v-30a60656] {\n  margin: 0;\n}\n.is-preview[data-v-30a60656] {\n  pointer-events: none;\n  cursor: default !important;\n}\n.is-preview *[data-v-30a60656] {\n  pointer-events: none;\n  cursor: default !important;\n}", ""]);
// Exports
module.exports = exports;
